import http from '@/libs/http'

export default {
  find(id) {
    return http.get(`/cms/endpoint/${id}`).then(result => result.data)
  },
  listAll(options = {}) {
    return http.get('/cms/endpoints', { params: options }).then(result => result.data)
  },
  findAll(options) {
    const limit = 10
    const params = Object.assign({
      limit,
      offset: (options.page - 1) * limit,
      sort_by: 'updated_at',
      order: 'desc'
    }, options)
    return http.get('/cms/endpoints', { params }).then(result => result.data)
  },
  create(model) {
    return http.post('/cms/endpoints', model).then(result => result.data).catch(error => error)
  },
  update(model) {
    return http.put(`/cms/endpoint/${model.id}`, this._clean(model)).then(result => result.data)
  },
  delete(id) {
    return http.delete(`/cms/endpoint/${id}`).then(result => result.data)
  },
  _clean(model) {
    const m = Object.assign({}, model)
    delete m.id
    return m
  }
}
